// Subcontractor Compliance inner page — Defence Card 02.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function SubcontractorCompliance() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.philosophy}
        eyebrow="Defence · Subcontractors and Compliance"
        headline="Defence-ready compliance for"
        italicWord="subcontractors."
        lede="We make the compliance pathway clear for fabricators, tradies and specialist subcontractors working with defence primes."
      />

      <section className="bg-black py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6">

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What this is</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              The compliance burden should not block capable businesses.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Subcontractors with genuine capability are regularly locked out of defence work because
              they cannot navigate the compliance requirements. The questionnaires are written for
              large enterprises. The standards assume a dedicated security team.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We translate those requirements into a practical programme that a trade business or
              specialist subcontractor can actually complete. Audits, policies and evidence packs,
              written in plain language and mapped to what the prime actually needs to see.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              From questionnaire to compliant in four to six weeks.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We review the specific requirements from your prime or your prospective customer.
              We run a gap assessment against your current practices, systems and documentation.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We generate the policy suite, remediate the critical gaps and deliver an evidence pack
              you can submit to procurement. We stay available to answer follow-up questions from
              the prime's security team.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You do the work. You just need to prove it.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You are a fabricator, installer, specialist subcontractor or trade business that has
              been asked to complete a defence supplier security assessment. You run a tight team
              and do not have in-house security expertise.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You want to access defence and government work in WA or nationally and need a
              compliance partner who works at your pace, not the pace of a big-four consultancy.
            </p>
          </Reveal>

        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
